function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { message, Skeleton, Descriptions, QRCode, Result } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircleFill, XCircleFill, HourglassSplit, QuestionCircleFill } from "react-bootstrap-icons";
import Common from '../components/includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var ScanDrugPrescription = function ScanDrugPrescription() {
  var _useParams = useParams(),
      id = _useParams.id;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isSearchDataLoading = _useState2[0],
      setIsSearchDataLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      customer = _useState4[0],
      setCustomer = _useState4[1];

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getcustomerresult/' + id).then(function (response) {
      if (response.data.status == 200) setCustomer(response.data.customer);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsSearchDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isSearchDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx("img", {
              src: "drawables/mvc.jpeg",
              style: {
                width: '100px'
              }
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          background: "#198794",
          padding: "25px 0px"
        },
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 1,
              md: 1,
              sm: 2,
              xs: 3,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  textAlign: "center"
                },
                children: /*#__PURE__*/_jsx("img", {
                  src: "drawables/mvlt.png",
                  style: {
                    width: '100%'
                  }
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx("h5", {
                style: {
                  color: "#FFFFFF",
                  textTransform: "uppercase"
                },
                children: "Authentification des certificats d'aptitude"
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [isSearchDataLoading == false && customer == null && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center"
              },
              children: [/*#__PURE__*/_jsx(QuestionCircleFill, {
                size: 85,
                style: {
                  color: "#AFA09D"
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h3", {
                children: "Informations introuvables !"
              })]
            }), customer && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center"
              },
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), customer != null && /*#__PURE__*/_jsxs(Descriptions, {
                column: 1,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "N\xBA "
                  }),
                  children: customer.candidate_code
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Nom "
                  }),
                  children: customer.name
                })]
              }), customer.conclusion.conclusion == 1 && /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(Result, {
                  status: "success",
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Apte au poste de travail occup\xE9"
                  }),
                  subTitle: customer.conclusion.comment
                })
              }), (customer.conclusion.conclusion == 4 || customer.conclusion.conclusion == 5 || customer.conclusion.conclusion == 6) && /*#__PURE__*/_jsx(Result, {
                status: "error",
                title: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [customer.conclusion.conclusion == 4 && /*#__PURE__*/_jsx("b", {
                    children: "Inapte temporaire au poste de travail occup\xE9"
                  }), customer.conclusion.conclusion == 5 && /*#__PURE__*/_jsx("b", {
                    children: "Inapte d\xE9finitif au poste de travail occup\xE9 avec reclassement"
                  }), customer.conclusion.conclusion == 6 && /*#__PURE__*/_jsx("b", {
                    children: "Inapte d\xE9finitif"
                  })]
                }),
                subTitle: customer.conclusion.comment
              }), (customer.conclusion.conclusion == 2 || customer.conclusion.conclusion == 3 || customer.conclusion.conclusion == 7) && /*#__PURE__*/_jsx(Result, {
                status: "info",
                title: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [customer.conclusion.conclusion == 2 && /*#__PURE__*/_jsx("b", {
                    children: "Apte au poste de travail occup\xE9 am\xE9nagement"
                  }), customer.conclusion.conclusion == 3 && /*#__PURE__*/_jsx("b", {
                    children: "Apte au poste de travail occup\xE9 avec restriction"
                  }), customer.conclusion.conclusion == 7 && /*#__PURE__*/_jsx("b", {
                    children: "Apte au poste occup\xE9 sous reserve d'une consultation"
                  })]
                }),
                subTitle: customer.conclusion.comment
              })]
            }), customer && customer.status == 1 && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center"
              },
              children: [/*#__PURE__*/_jsx(CheckCircleFill, {
                size: 85,
                style: {
                  color: "#3B944E"
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), customer != null && /*#__PURE__*/_jsxs(Descriptions, {
                column: 1,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "RNC "
                  }),
                  children: customer.rnc
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Nom "
                  }),
                  children: customer.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Pr\xE9nom "
                  }),
                  children: customer.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Groupe"
                  }),
                  children: customer.laboresult = !null ? customer.laboresult.group + '' + customer.laboresult.rhesus : '--'
                })]
              })]
            }), customer && customer.status == 2 && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center"
              },
              children: [/*#__PURE__*/_jsx(XCircleFill, {
                size: 85,
                style: {
                  color: "#1AAF41"
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), customer != null && /*#__PURE__*/_jsxs(Descriptions, {
                column: 1,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "RNC"
                  }),
                  children: customer.rnc
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Nom"
                  }),
                  children: customer.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Pr\xE9nom"
                  }),
                  children: customer.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Groupe"
                  }),
                  children: customer.laboresult = !null ? customer.laboresult.group + '' + customer.laboresult.rhesus : '--'
                })]
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(QRCode, {
                errorLevel: "H",
                size: 150,
                iconSize: 150 / 4,
                value: "https://mt.centremedvie.com/#/check/" + id,
                icon: "drawables/mvc.jpeg"
              })
            })]
          })
        })
      })]
    })
  });
};

export default ScanDrugPrescription;